<template>
  <div id="page-projects">
    <ContentHeader>
      <h6 class="header__meta-title">{{ $wp.metaTitle }}</h6>
      <h1 class="header__title">{{ $wp.header.title }}</h1>
      <h3 class="header__subtitle">
        <Icon id="chat" class="header__subtitle-icon" />
        <span class="header__subtitle-text">{{ $wp.header.subtitle }}</span>
      </h3>
    </ContentHeader>
    <ContentSplit :title="$wp.intro.title" :image="$wp.intro.image">
      <ContentRaw :html="$wp.intro.content" />
    </ContentSplit>
    <WorkshopIntroSection ref="scrollDestination" :content="workshopIntroSection"></WorkshopIntroSection>
    <WorkshopSection v-for="(workshop, index) in $wp.workshops" :key="index" :content="workshop" />
    <Transition name="fade">
      <button v-show="isButtonVisible" class="button-scroll" @click="scrollTop">
        <Icon id="arrow" class="button-scroll__icon"></Icon>
      </button>
    </Transition>
  </div>
</template>

<script>
import { Icon } from '@/components/global'
import { ContentHeader, ContentSplit, ContentRaw } from '@/components/content'
import { WorkshopIntroSection, WorkshopSection } from '@/components/partials'

export default {
  name: 'Projects',
  contentKey: 'projects2',
  components: { ContentHeader, ContentRaw, ContentSplit, Icon, WorkshopIntroSection, WorkshopSection },
  data() {
    return {
      isButtonVisible: false
    }
  },
  computed: {
    workshopIntroSection() {
      return {
        description: this.$wp.orientation.description,
        title: this.$wp.orientation.title,
        workshops: this.$wp.workshops
      }
    }
  },
  mounted() {
    this.$refs.introSection = document.getElementById('workshopIntro')
    window.setTimeout(this.setScrollEvent, 1000)
  },
  methods: {
    removeHash() {
      if (this.$route.hash) {
        this.$router.replace({ hash: '' })
      }
    },
    scrollTop() {
      const bannerHeight =
        document.getElementById('navbar').offsetHeight + document.getElementById('navbanner').offsetHeight
      this.$refs.viewport.scrollTo({
        top: this.$refs.scrollDestination.$el.offsetTop - bannerHeight,
        behavior: 'smooth'
      })
      this.removeHash()
    },
    setScrollEvent() {
      this.$refs.viewport = document.querySelector('.simplebar-content-wrapper')
      this.$refs.viewport.addEventListener('scroll', this.showHideButton)
    },
    showHideButton() {
      this.isButtonVisible =
        this.$refs.viewport.scrollTop + this.$refs.viewport.getBoundingClientRect().height - 88 >
        this.$refs.introSection.offsetTop
    }
  }
}
</script>
